import React from 'react';
import { FaChartBar, FaUserGraduate } from 'react-icons/fa';
import { useApp } from '../../../context/AppContext';
import { DashboardChartGrid, KpiGrid, PortalHero } from '../../../components_shared/PortalDashboard';

export default function PEODashboardPage(){
  const { user } = useApp();
  const cards=[
    {icon:<FaChartBar/>, label:'Enrollment Reports', value:5, className:'eduss-dashboard-card-blue'},
    {icon:<FaUserGraduate/>, label:'Students Today', value:320, className:'eduss-dashboard-card-yellow'}
  ];
  return (
    <div className="eduss-dashboard">
      <PortalHero title={`Welcome, ${user?.username || 'PEO'}!`} subtitle="Review enrollment reports and student collection movement." />
      <KpiGrid cards={cards.map(c=>({...c,desc:'Current enrollment count'}))} />
      <DashboardChartGrid charts={[
        {title:'Enrollment Workload',caption:'Today',type:'bar',data:cards.map(c=>({name:c.label,value:c.value})),color:'#0f6fad'},
        {title:'Student Trend',caption:'Snapshot',type:'line',data:cards.map(c=>({name:c.label,value:c.value})),color:'#10ac84'}
      ]} />
    </div>
  );
}
